import * as actionTypes from './actionTypes';
import axios from '../../axios/Backend';
// import { setLoggedUserToken } from '../../util/loggedUser'


export const loginStart = (isBtnLogginTouched = false) => {
    return {
        type: actionTypes.Login_START,
        isBtnLogginTouched: isBtnLogginTouched
    };
};

export const loginSuccess = (loginData) => {
    return {
        type: actionTypes.Login_SUCCESS,
        idToken: loginData.token,
        userId: loginData.user._id,
        email: loginData.user.email,
        agentName: loginData.user.agentName,
        name: loginData.user.name,
        permissionType: loginData.user.permissionType,
        canDeleteChat: loginData.user.canDeleteChat,
        companyId: loginData.user.companyId,
        avatar: loginData.user.avatar,
        urlOnNewContact: loginData.user.urlOnNewContact,
        extId: loginData.user.extId,
        device: loginData.user.device,
        biUrl: loginData.user.biUrl,
        facebook_pageAccess: loginData.user.facebook_pageAccess,
        groupList: loginData.user.groupList,
        companyDetails: loginData.user.companyDetails,
        lastReadChangeLogTime : loginData.user.lastReadChangeLogTime,
        tokenExpiresInMin : loginData.tokenExpiresIn,
        supportedMsgTypes : loginData.user.supportedMsgTypes
    };
};

export const loginFail = (error) => {
    return {
        type: actionTypes.Login_FAIL,
        error: error
    };
};

export const logout = () => {
    return async dispatch => {
        try {

            const objToDispatch = {
                type: actionTypes.LOGIN_LOGOUT
            }
            dispatch(objToDispatch)

        } catch (e) {
            console.log(e)
        }
    }
};

// export const checkLoginTimeout = (expirationTime) => {
//     return dispatch => {
//         setTimeout(() => { dispatch(logout()) }, expirationTime * 1000)
//     };
// };

export const login = (email, password, isBtnLogginTouched = false,reCaptchaValue) => {

    return async dispatch => {
        try {
            dispatch(loginStart(isBtnLogginTouched))
            const dataTosend = {
                email: email,
                password: password,
                reCaptchaValue
            };
            const resData = await axios.post('/users/login', dataTosend);//{ withCredentials: true }
            const data = resData.data;
            //console.log(data);
            // const expirationDate = new Date(new Date().getTime() + data.expirationTime * 1000);
            // localStorage.setItem('token', data.token);
            // setLoggedUserToken(data.token)
            // localStorage.setItem('expirationDate', expirationDate);
            // localStorage.setItem('userId', data.user._id);

            dispatch(loginSuccess(data));
            // dispatch(checkLoginTimeout(data.expirationTime));
        }
        catch (e) {
            dispatch(loginFail(e.response?.data?.message ? e.response.data.message : 'Unable to connect, please contact system administrator.'));
            console.log(e);
        }
    }
}

export const fetchFacebookLoginSuccess = (isFaceBookLogged) => {
    return {
        type: actionTypes.FETCH_FACEBOOK_LOGIN_SUCCESS,
        isFaceBookLogged: isFaceBookLogged
    };
};

export const fetchFacebookSubscribedPages = () => {
    return async dispatch => {
        try {
            const res = await axios.get('/users/getfacebooksubscribedpages');
            const resData = res.data;
            const dispatchObj = {
                type: actionTypes.FETCH_FB_SUBS_PAGES,
                facebook_pageAccess: resData
            }
            dispatch(dispatchObj)
        }
        catch (e) {
            console.log(e);
        }
    }
};

export const fetchFacebookLogin = () => {//fetchFacebookLoginSuccess

    return async dispatch => {
        try {
            // console.log('fetchFacebookLogin')
            // const token = localStorage.getItem('token');
            const res = await axios.get('/company/getFacebookLogin');
            const resData = res.data;
            const nowUnixTime = Date.now()
            if (resData.userToken_expiration_time || resData.userToken_expiration_time === 0) {
                if (resData.userToken_expiration_time * 1000 > nowUnixTime || resData.userToken_expiration_time === 0) {
                    dispatch(fetchFacebookLoginSuccess(true));
                }
            }
            else {
                dispatch(fetchFacebookLoginSuccess(false));
            }

        }
        catch (e) {

            console.log(e);
        }
    }
}

export const loginCheckState = () => {
    return async dispatch => {
        try {
            dispatch(loginStart())
            // const token = localStorage.getItem('token');
            // if (!token) {
            //     dispatch(logout());
            //     dispatch(loginFail('please log in again'));
            // }
            // else {
            // const expirationDate = new Date(localStorage.getItem('expirationDate'));

            // if (expirationDate > new Date()) {
            //const userId = localStorage.getItem('userId');

            const resData = await axios.get('/users/login-with-token');
            const data = resData.data

            dispatch(loginSuccess(data));
            // let expirationSec = expirationDate.getTime();
            // let nowSec = new Date().getTime();
            // dispatch(checkLoginTimeout((expirationSec - nowSec) / 1000));
            // } else {
            //     dispatch(logout());
            // }
            // }
        } catch (e) {
            dispatch(loginFail(e.message));
            console.log(e);
        }
    }

}


export const uploadAvatar = (avatar) => {
    return async dispatch => {
        try {
            await axios.post('/users/me/avatar', avatar);
        } catch (e) {
            console.log(e);
        }
    }
}

//online agents
export const companyOnlineAgents = (onlineAgent, action) => {
    return (
        {
            type: actionTypes.ONLINE_AGENTS,
            onlineAgent: onlineAgent,
            action: action
        }
    );
};

//refresh media token
export const refreshMediaToken = (mediaTokenData) => {
    return (
        {
            type: actionTypes.REFRESH_MEDIA_TOKEN,
            mediaTokenData
        }
    );
};

//fetchAgents
export const fetchAgentsSuccess = (companyAgents) => {
    return (
        {
            type: actionTypes.FETCH_AGENTS_SUCCESS,
            companyAgents: companyAgents
        }
    );
};


export const onGroupsActions = (data, actionName) => {
    return async dispatch => {
        try {
            dispatch({
                type: actionName,
                data: data
            })
        } catch (e) {
            console.log(e)
        }
    }
}

export const fetchAgents = () => {
    return async dispatch => {
        try {
            const resData = await axios.get('/company/getAgents');
            const data = resData.data;
            dispatch(fetchAgentsSuccess(data))
        } catch (e) {
            console.log(e)
        }
    }
}

//fetchAgents
export const fetchGroupsSuccess = (company_groupList) => {
    return (
        {
            type: actionTypes.FETCH_GROUPS_SUCCESS,
            company_groupList: company_groupList
        }
    );
};

export const fetchCompanyGroups = () => {
    return async dispatch => {
        try {
            const resData = await axios.get('/group/grouplist');
            const data = resData.data;
            dispatch(fetchGroupsSuccess(data))
        } catch (e) {
            console.log(e)
        }
    }
}

export const fetchAgentWindowSuccess = (resData) => {
    return (
        {
            type: actionTypes.FETCH_AGENT_WINDOW_SUCCESS,
            resData: resData
        }
    );
};

// export const fetchAgentWindow = () => {
//     return async dispatch => {
//         let data = {}
//         let resDataAgentBreakReasonsData = []
//         try {
//             const resData = await axios.get('/agentServices/getAgentWindowState');
//             data = resData.data;
//         } catch (e) {
//             console.log(e)
//         }
//         try {
//             const resDataAgentBreakReasons = await axios.get('/agentServices/getBreakReasons');
//             resDataAgentBreakReasonsData = resDataAgentBreakReasons.data;
//             const toDispatch = {
//                 ...data,
//                 breakReasons: resDataAgentBreakReasonsData
//             }
//             dispatch(fetchAgentWindowSuccess(toDispatch))
//         } catch (e) {
//             console.log(e)
//         }
//     }
// }

export const fetchAgentWindow = (agentWindowStateData,breakReasonsData) => {
    return async dispatch => {
        const toDispatch = {
            ...agentWindowStateData,
            breakReasons: breakReasonsData
        }
        dispatch(fetchAgentWindowSuccess(toDispatch))
    }
}

export const changeAgentWindowState = (newAgentStateData) => {
    return async dispatch => {
        try {
            // console.log(newAgentStateData)
            let updatedAgentWindowState = {
                type: actionTypes.CHANGE_AGENT_WINDOW_STATE,
                toUpdate: { ...newAgentStateData }
            }
            // console.log(updatedAgentWindowState)
            dispatch(updatedAgentWindowState)
        } catch (e) {
            console.log(e)
        }
    }
}

export const incBreakSec = (numToInc) => {
    return async dispatch => {
        try {
            // console.log(newAgentStateData)
            let dispatchData = {
                type: actionTypes.INCREASE_BREAK_SEC,
                numToInc: numToInc
            }
            // console.log(updatedAgentWindowState)
            dispatch(dispatchData)
        } catch (e) {
            console.log(e)
        }
    }
}

export const changeAgentDialerState = (isDialerActiveObj) => {
    return async dispatch => {
        try {
            //  console.log(isDialerActiveObj)
            let dispatchData = {
                type: actionTypes.CHANGE_AGENT_DIALER_STATE,
                ...isDialerActiveObj
            }
            // console.log(updatedAgentWindowState)
            dispatch(dispatchData)
        } catch (e) {
            console.log(e)
        }
    }
}

const fetchAgentTempMsgSuccess = (tempMsgs) => {
    return {
        type: actionTypes.FETCH_AGENT_TEMPMSG_SUCCESS,
        tempMsgs: tempMsgs
    }
}

export const fetchCompanyExtsSuccess = (companyExts) => {
    return {
        type: actionTypes.FETCH_COMPANY_EXTS_SUCCESS,
        companyExts: companyExts
    }
}

export const fetchAgentTempMsg = () => {

    return async dispatch => {
        try {
            const resDatatempMsgs = await axios.get('/agentServices/getTempMsg');
            const TempMsgs = resDatatempMsgs.data
            if (TempMsgs.success === true) {
                dispatch(fetchAgentTempMsgSuccess(TempMsgs.tempMsgs))
            }
            else {
                return console.log('something was wrong with getting temp msgs')
            }

        } catch (e) {
            console.log(e)
        }
    }

}



export const setPbxConnectedStatus = (isPbxConnected, PbxConnectionStatus) => {
    return async dispatch => {
        try {
            const dispatchObg = {
                type: actionTypes.SET_PBX_CONNECTED_STATUS,
                isPbxConnected: isPbxConnected,
                PbxConnectionStatus: PbxConnectionStatus
            }
            dispatch(dispatchObg)

        } catch (e) {
            console.log(e)
        }
    }
}
